let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dthcp")).then(() => parcelRequire('7Wn3a'));